import TableDynamic from "../../components/TableDynamic";
import React from "react";
import { Button, Alert, Card, Spinner } from "react-bootstrap";
import { store } from "../../reducer/Store";
import ApiService from "../../services/ApiService";
import VisuelRapportModal from "../../components/visuelrapport/VisuelRapportModal";
const VisuelRapport = () => {
  const { dispatch, state } = React.useContext(store);
  const [image, setImage] = React.useState();
  const [showAdd, setShowAdd] = React.useState(false);
  const [errorFormatFile, setErrorFormatFile] = React.useState(false);
  const [errorNotASquare, setErrorNotASquare] = React.useState(false);
  const [warningTooSmall, setWarningTooSmall] = React.useState(false);
  const [errorHeavyFile, setErrorHeavyFile] = React.useState(false);
  const [showUpdate, setShowUpdate] = React.useState(false);
  const [brandImageData, setBrandImageData] = React.useState("");
  const [brandId, setBrandId] = React.useState("");

  const handleClose = () => {
    setErrorFormatFile(false);
    setErrorNotASquare(false);
    setWarningTooSmall(false);
    setErrorHeavyFile(false);
    setImage();
    setBrandId("");
    setErrorFormatFile("");
    setBrandImageData([]);
    setShowUpdate(false);
    setShowAdd(false);
  };
  const handleShowUpdate = (brandImage) => {
    setBrandImageData(brandImage);
    setShowUpdate(true);
  };
  const handleShowAdd = () => setShowAdd(true);
  const columnsName = ["Marque", "Visuel de la marque", ""];
  const columns = ["brand", "content", "updateAndDelete"];

  /**
   * Cette fonction récupère les visuels de rapport correspondant aux marques sélectionnées et à l'année en cours à partir de l'API et les stocke dans le state de l'application.
   * @returns {void}
   */
  const getVisuelRapport = async () => {
    var brands = [];
    JSON.parse(localStorage.getItem("currentBrands")).map((brand) =>
      brands.push(brand.value)
    );
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      `brand-images-by-brands-year/${brands}/${
        JSON.parse(localStorage.getItem("currentYear")).value
      }`,
      "get"
    )
      .then(function (response) {
        dispatch({ type: "SET_LOADER", payload: false });
        dispatch({ type: "SET_VISUELRAPPORT", payload: response.data });
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        dispatch({ type: "SET_VISUELRAPPORT", payload: [] });
        console.log(error.response.data.message);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction met à jour le visuel de rapport spécifié avec une nouvelle image, à partir de l'API et stocke les nouvelles données dans le state de l'application.
   * @param {string} image - La nouvelle image à utiliser pour mettre à jour le visuel de rapport.
   * @returns {void}
   */
  const updateVisuelRapport = (image) => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        content: image,
        brand_id: brandImageData.brand_id,
        year_id: brandImageData.year_id,
      },
      `brand-images/${brandImageData.id}`,
      "put"
    )
      .then(function () {
        dispatch({ type: "SET_LOADER", payload: false });
        handleClose();
        getVisuelRapport();
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error.response.data.message);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction ajoute une image à un rapport en envoyant une requête à l'API.
   * @param { File } image - L'image à ajouter, qui doit être de type File.
   */
  const addVisuelRapport = (image) => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        content: image,
        brand_id: brandId,
        year_id: state.currentYear.value,
      },
      `brand-images`,
      "post"
    )
      .then(function () {
        dispatch({ type: "SET_LOADER", payload: false });
        handleClose();
        getVisuelRapport();
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error.response.data.message);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction supprime un visuel de rapport en envoyant une requête à l'API.
   * Elle affiche également une confirmation à l'utilisateur avant de procéder à la suppression.
   * @param { Object } visuelRapport - L'objet visuelRapport à supprimer.
   */
  const deleteVisuelRapport = (visuelRapport) => {
    if (
      window.confirm(
        "Êtes vous sûr de vouloir supprimer le visuel de la marque " +
          visuelRapport.brand.name +
          " ?"
      )
    ) {
      dispatch({ type: "SET_LOADER", payload: true });
      ApiService.request({}, "brand-images/" + visuelRapport.id, "delete")
        .then(function () {
          dispatch({ type: "SET_LOADER", payload: false });
          getVisuelRapport();
        })
        .catch(function (error) {
          dispatch({ type: "SET_LOADER", payload: false });
          console.log(error);
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    }
  };

  /**
   * Cette fonction gère le changement d'image et effectue des validations sur celle-ci avant de l'assigner à l'état de l'application.
   * @param { Event } event - L'événement de changement de fichier déclenché par l'utilisateur.
   */
  const handleImageChange = (event) => {
    setErrorFormatFile(false);
    setErrorNotASquare(false);
    setWarningTooSmall(false);
    setErrorHeavyFile(false);
    const selectedFile = event.target.files[0];
    if (
      selectedFile.type !== "image/jpeg" &&
      selectedFile.type !== "image/png"
    ) {
      setErrorFormatFile(true);
    }
    setImage(selectedFile);
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        if (img.width !== img.height) {
          setErrorNotASquare(true);
        }
        if (img.width !== 1500 || img.height !== 1500) {
          setWarningTooSmall(true);
        }
      };
      if (selectedFile.size > 2500000) {
        setErrorHeavyFile(true);
      }
      img.src = e.target.result;
    };
    reader.readAsDataURL(selectedFile);
  };

  React.useEffect(() => {
    if (state.currentBrands.length > 0) {
      getVisuelRapport();
    } else {
      dispatch({ type: "SET_VISUELRAPPORT", payload: [] });
    }
  }, [state.currentYear, state.currentBrands]);

  return (
    <>
      <h1>Visuel rapport</h1>

      {showAdd && (
        <VisuelRapportModal
          handleClose={handleClose}
          show={showAdd}
          addOrUpdateVR={addVisuelRapport}
          handleImageChange={handleImageChange}
          setImage={setImage}
          nameModal={"Ajouter"}
          image={image}
          errorFormatFile={errorFormatFile}
          errorNotASquare={errorNotASquare}
          errorHeavyFile={errorHeavyFile}
          warningTooSmall={warningTooSmall}
        />
      )}
      {showUpdate && (
        <VisuelRapportModal
          handleClose={handleClose}
          show={showUpdate}
          addOrUpdateVR={updateVisuelRapport}
          handleImageChange={handleImageChange}
          setImage={setImage}
          image={image}
          nameModal={"Modifier"}
          errorFormatFile={errorFormatFile}
          errorNotASquare={errorNotASquare}
          errorHeavyFile={errorHeavyFile}
          warningTooSmall={warningTooSmall}
        />
      )}

      {state.currentBrands.length > 0 ? (
        !state.loader ? (
          <>
            {state.currentBrands.map((brand, i) => (
              <div key={i}>
                {state.visuelRapport.some(
                  (vR) => vR.brand_id === parseInt(brand.value)
                ) ? (
                  ""
                ) : (
                  <div className="m-2">
                    <Button
                      onClick={() => {
                        setBrandId(parseInt(brand.value));
                        handleShowAdd(true);
                      }}
                    >
                      Créer le visuel de la marque {brand.label}
                    </Button>
                  </div>
                )}
              </div>
            ))}
            <TableDynamic
              columnsName={columnsName}
              columns={columns}
              data={state.visuelRapport}
              showUpdate={handleShowUpdate}
              deleteD={deleteVisuelRapport}
            ></TableDynamic>
          </>
        ) : (
          <div className="text-center">
            <Spinner
              animation={state.loader ? "border" : false}
              role="status"
            ></Spinner>
          </div>
        )
      ) : (
        <Card className="text-center">
          <Card.Body>
            <Alert variant="danger" className="m-0">
              Veuillez sélectionner au moins une marque.
            </Alert>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default VisuelRapport;
